module.exports = __webpack_public_path__ + "static/media/Spider Lady.1ae64b11.jpg";